var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotFound = function SvgNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 84,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8004 8.92H11.5804C9.70818 8.92 8.19043 10.4378 8.19043 12.31V78.53C8.19043 80.4022 9.70818 81.92 11.5804 81.92H65.8004C67.6727 81.92 69.1904 80.4022 69.1904 78.53V12.31C69.1904 10.4378 67.6727 8.92 65.8004 8.92Z",
    fill: "var(--konflux-primary-color, #FF9D76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 69.82V4.1C2 2.94 2.94 2 4.1 2H47.83C48.39 2 48.92 2.22 49.31 2.61L60.32 13.62C60.71 14.01 60.93 14.55 60.93 15.1V69.82C60.93 70.98 59.99 71.92 58.83 71.92H4.1C2.94 71.92 2 70.98 2 69.82Z",
    stroke: "var(--konflux-icon-color, #1A1A1A)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9502 2V13.89C46.9502 15.05 47.8902 15.99 49.0502 15.99H60.9402",
    stroke: "var(--konflux-icon-color, #1A1A1A)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7695 75.26L69.1995 81.69",
    stroke: "var(--konflux-icon-color, #1A1A1A)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1904 64.54C39.1904 71.65 44.9504 77.4 52.0504 77.4C55.6104 77.4 58.8304 75.95 61.1604 73.62C63.4804 71.29 64.9204 68.08 64.9204 64.54C64.9204 57.43 59.1604 51.68 52.0604 51.68C44.9604 51.68 39.2004 57.44 39.2004 64.54H39.1904Z",
    fill: "white",
    stroke: "var(--konflux-icon-color, #1A1A1A)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8398 42.07V38.89L18.1098 28.48H22.5098V38.66H24.3998V42.07H22.5098V45.06H18.5698V42.07H10.8398Z",
    fill: "var(--konflux-icon-color, #1A1A1A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8505 32.81L14.9805 38.66H18.8505V32.81Z",
    fill: "var(--konflux-primary-color, #FF9D76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8698 30.19C28.8898 28.67 30.5398 27.91 32.8098 27.91C35.0798 27.91 36.7298 28.67 37.7498 30.19C38.7698 31.71 39.2798 33.79 39.2798 36.43C39.2798 39.07 38.7698 41.2 37.7498 42.72C36.7298 44.24 35.0798 45 32.8098 45C30.5398 45 28.8898 44.24 27.8698 42.72C26.8498 41.2 26.3398 39.1 26.3398 36.43C26.3398 33.76 26.8498 31.71 27.8698 30.19Z",
    fill: "var(--konflux-icon-color, #1A1A1A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 32.85C34.5604 32.01 33.8604 31.59 32.8004 31.59C31.7404 31.59 31.0404 32.01 30.7004 32.85C30.3604 33.69 30.1904 34.88 30.1904 36.43C30.1904 37.47 30.2504 38.34 30.3704 39.02C30.4904 39.7 30.7404 40.26 31.1204 40.68C31.5004 41.1 32.0504 41.31 32.7904 41.31C33.5304 41.31 34.0804 41.1 34.4604 40.68C34.8404 40.26 35.0804 39.7 35.2104 39.02C35.3304 38.34 35.3904 37.47 35.3904 36.43C35.3904 34.88 35.2204 33.69 34.8804 32.85H34.9004Z",
    fill: "var(--konflux-primary-color, #FF9D76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4404 42.07V38.89L47.7204 28.48H52.1204V38.66H54.0104V42.07H52.1204V45.06H48.1804V42.07H40.4404Z",
    fill: "var(--konflux-icon-color, #1A1A1A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4598 32.81L44.5898 38.66H48.4598V32.81Z",
    fill: "var(--konflux-primary-color, #FF9D76)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.2,
    height: 83.69,
    fill: "white"
  })))));
};
export default SvgNotFound;